import React from "react";
import { Link } from "react-router-dom";
import "./Footer.css";
export default function Footer() {
  return (
    <div className="footer-section ">
      <div className="footer-main">
        <div className="container footer-bottom-content">
          <span>© 2024 Kaamvala Copy Right . All Rights Reserved.</span>
          <span className="separator">|</span>
          <Link to="/privacy-policy" className="privacy-link">
            Privacy Policy
          </Link>
          <Link to="/terms-condition" className="privacy-link">
            Terms & Condition
          </Link>
          <Link to="/refund-cancellation" className="privacy-link">
            Refund and Cancellation
          </Link>
        </div>
      </div>
    </div>
  );
}
